var $dff280acfeb2d8ac$exports = {};
$dff280acfeb2d8ac$exports = {
    "longPressMessage": `Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool`
};


export {$dff280acfeb2d8ac$exports as default};
//# sourceMappingURL=et-EE.module.js.map
